function clearCommonKeys() {
  localStorage.removeItem("id_token");
  localStorage.removeItem("id_token_exp");
  localStorage.removeItem("ciq_email");
  localStorage.removeItem("location_id");
  localStorage.removeItem("portalContext");
  localStorage.removeItem("portalHomeUrl");
  localStorage.removeItem("ciq_can_show_language_prompt");
}

/**
 * Clear only specific keys from storage for remote patients.
 * We need to avoid clearing other important keys,
 * e.g. Transifex or Pendo data
 */
export function clearRemotePatientSession() {
  clearCommonKeys();

  sessionStorage.removeItem("ciq_id");
  localStorage.removeItem("ciq_id");
  localStorage.removeItem("launch_survey_kind");
}

/**
 * Clear only specific keys from storage for kiosk patients.
 * We need to avoid clearing other important keys,
 * e.g. Transifex or Pendo data
 */
export function clearKioskPatientSession() {
  clearCommonKeys();

  localStorage.removeItem("sessionId");
  localStorage.removeItem("surveyCode");
  localStorage.removeItem("surveyType");
  localStorage.removeItem("disableZendesk");
  localStorage.removeItem("ciq-questionnaire.sessionId");
}
